import { useState } from "react";

export default function SearchableSelectBox({
  label,
  value,
  onChange,
  options,
  placeholder,
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filtered = options.filter((opt) =>
    opt.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-full">
      <label className="block mb-1 font-medium text-sm">{label}</label>

      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className="input input-bordered w-full flex justify-between items-center"
        >
          <span>
            {options.find((o) => o.id === value)?.name || placeholder}
          </span>
          <span className="opacity-50">▾</span>
        </button>

        {open && (
          <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg">
            <input
              type="text"
              placeholder="Rechercher..."
              className="input input-bordered w-full rounded-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />

            <div className="max-h-60 overflow-y-auto">
              {filtered.length === 0 && (
                <div className="px-4 py-2 text-gray-500">Aucun résultat</div>
              )}

              {filtered.map((opt) => (
                <div
                  key={opt.id}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    onChange(null, opt.id);
                    setOpen(false);
                    setSearch("");
                  }}
                >
                  {opt.name}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
